import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Tooltip,
  Typography
} from "@mui/material";
import theme from "../../styles/theme";
import Icon from "../icon";
import React from "react";
import PropTypes from 'prop-types';

function ContentCard({ title, subtitle, link, icon, img, handleClick }) {
  
  ContentCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    icon: PropTypes.element,
    img: PropTypes.string,
    handleClick: PropTypes.func,
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        backgroundColor: "background.white",
        boxShadow: theme.palette.box.shadow,
      }}
      onClick={handleClick}
    >
      <CardActionArea href={link}  >
        <CardContent sx={{ height: "190px" }}>
          <Grid container rowGap={2} direction={"column"}>
            {icon}
            <Typography
              variant="h5"
              fontWeight={400}
              gutterBottom
              component="div"
              color={"text.main"}
              style={{
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                display: "-webkit-box",
              }}
            >
              {title}
            </Typography>
          </Grid>
          <Tooltip title={subtitle}>
            <Typography
              heivariant="body1"
              color={"primary.main"}
              style={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                display: "-webkit-box",
              }}
            >
              {subtitle}
            </Typography>
          </Tooltip>
        </CardContent>
        <CardActions sx={{ justifyContent: "end" }}>
          <Icon name="ArrowForwardRounded" sx={{ color: "inherit" }} />
        </CardActions>
      </CardActionArea>
     
    </Card>
  );
}
export default ContentCard;
